const theme = {
    colors: {
        active: '#ffcb6e',
        active2: '#ffbbbb',
        brown1: '#56270c',
    },
}

export default theme;
